import React, { useState } from "react";
import { useEffect, useRef } from "react";
import { useSearchParams, Link } from "react-router-dom";
import styles from "./styles.module.css";
import BaseApi from "../../../services/Api";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { findIndex } from "lodash";
import ModalAnimal from "../../../components/Modals/ModalAnimal";
import Pagination from "../../../components/Layout/Pagination";
import { Spinner } from "react-bootstrap";
import TableContainer from "../../../components/Layout/TableContainer";
import ModalAnimalInfo from "../../../components/Modals/ModalAnimal/info";
import { format } from "date-fns";
import ptBR from 'date-fns/locale/pt-BR';

const INITIAL_DATA = {
  total: 0,
  current_page: 1,
  last_page: 1,
  first_page_url: "",
  last_page_url: "",
  next_page_url: "",
  prev_page_url: null,
  path: "",
  from: 1,
  to: 1,
  data: [],
};

export default function Animals() {
  let [searchParams, setSearchParams] = useSearchParams();

  let controller = new AbortController();

  const INITIAL_FILTERS = {
    search: searchParams.get("search") || "",
    species: [],
    size: [],
    phase: [],
    is_castrated: [],
    special_animal: [],
    is_pinned: [],
    was_adopted: [],
  };

  const INITIAL_QUERY = {
    sort: "id",
    order: "desc",
    per_page: 10,
    page: searchParams.get("page") || 1,
  };

  const [isLoading, setLoading] = React.useState(true);
  const [isFiltering, setFiltering] = React.useState(true);
  const [isPaginating, setPaginating] = React.useState(true);

  const [query, setQuery] = React.useState({
    ...INITIAL_QUERY,
    ...INITIAL_FILTERS,
  });
  const [filters, setFilters] = React.useState({ ...INITIAL_FILTERS });
  const [tableData, setTableData] = React.useState({ ...INITIAL_DATA });

  const requestData = (args = {}) => {
    setLoading(true);
    let q = { ...query, ...args };
    BaseApi.get("/animais", {
      signal: controller.signal,
      params: {
        ...q,
        search: q.search !== "" ? q.search : undefined,
      },
    })
      .then((response) => {
        setTableData(response.data);
        setLoading(false);
        setPaginating(false);
        setFiltering(false);
      })
      .catch((err) => {
        if (err) {
          console.log(err);
          toast.error("Erro ao carregar dados da tabela");
          setTableData({ ...INITIAL_DATA });
          setLoading(false);
          setPaginating(false);
          setFiltering(false);
        }
      });
  };

  const setSearch = (args = {}) => {
    let params = { ...args };
    if (filters.search && filters.search !== "") params.q = filters.search;
    setSearchParams(params);
  };

  const handlePagination = (page) => {
    setSearch({ p: page });
    setPaginating(true);
    setQuery({ ...query, page });
  };

  const handleFilters = (e) => {
    e.preventDefault();
    setSearch();
    setFiltering(true);
    setQuery({ ...query, ...filters, page: 1 });
  };

  const handleCreateAnimal = () => {
    setLoading(true);
    setFilters({ ...INITIAL_FILTERS });
    setQuery({ ...INITIAL_QUERY });
  };

  const handleUpdateAnimal = (animal) => {
    let data = [...tableData.data];
    let toUpdate = findIndex(data, { id: animal.id });
    if (toUpdate === -1) return;
    data[toUpdate] = { ...data[toUpdate], ...animal };
    setTableData({ ...tableData, data: data });
  };

  const onDelete = (animal) => {
    Swal.fire({
      title: "Tem certeza que deseja apagar o animal?",
      text: "Essa ação não pode ser revertida!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim, delete!",
    }).then(({ isConfirmed }) => {
      if (isConfirmed) {
        setLoading(true);
        BaseApi.delete(`/animais/${animal.id}`)
          .then(res => {
            toast.success('Animal Deletado com sucesso!');
            requestData();
          })
          .catch(err => {
            Swal.fire('Oops!', err?.data?.errors?.[0] || err?.data?.message || 'Ocorreu um erro ao deletar este animal.', 'error');
            setLoading(false);
          }).finally(() => setLoading(false));
      }
    });
  };

  const handleSelectAnimals = (e, type) => {
    let data = [...query[type]];
    let {value, checked} = e.target;

    if(checked) {
      data.push(value);
    } else {
      data = data.filter((item) => item !== value);
    }
    let copy = {...query};
    copy[type] = data;
    setQuery(copy);
  }

  useEffect(() => {
    controller = new AbortController();
    requestData();
    return () => {
      controller.abort();
      setLoading(true);
    };
  }, [query]);

  return (
    <>
      <div className="d-flex flex-column">
        <div className={"d-flex flex-column flex-md-row pb-4"}>
          <div className={`${styles.animal} col-12 col-md-4 mb-2`}>
            <h1>Animais</h1>
          </div>
          <div className="col-12 col-md-6 mb-2">
            <form onSubmit={handleFilters} className="d-flex flex-row">
              <input
                type="text"
                className="form-control "
                placeholder="Pesquisa"
                aria-label="Pesquisa"
                value={filters.search}
                onChange={(e) =>
                  setFilters({ ...filters, search: e.target.value })
                }
              />
              <button className="btn btn-outline-success ms-2" type="submit">
                <span>Pesquisa</span>
              </button>
            </form>
          </div>
          <div className="col-12 col-md-2 d-flex justify-content-end mb-2">
            <ModalAnimal onCreate={handleCreateAnimal}>
              <button className="btn btn-outline-success ms-2" type="button">
                <span>Criar</span>
              </button>
            </ModalAnimal>
          </div>
        </div>
        <div className={styles.btnGroup}>
          <input type="checkbox" className="w-auto btn-check" id="cat" value="cat" onChange={(e) => handleSelectAnimals(e, 'species')} onClick={(e) => e.stopPropagation()}></input>
          <label for="cat">Gato</label>
          
          <input type="checkbox" className="w-auto btn-check" id="dog" value="dog" onChange={(e) => handleSelectAnimals(e, 'species')} onClick={(e) => e.stopPropagation()}></input>
          <label for="dog">Cachorro</label>
          
          <input type="checkbox" className="w-auto btn-check" id="cub" value={'cub'} onChange={(e) => handleSelectAnimals(e, 'phase')} onClick={(e) => e.stopPropagation()}></input>
          <label for="cub">Filhote</label>
          
          <input type="checkbox" className="w-auto btn-check" id="adult" value={'adult'} onChange={(e) => handleSelectAnimals(e, 'phase')} onClick={(e) => e.stopPropagation()}></input>
          <label for="adult">Adulto</label>
          
          <input type="checkbox" className="w-auto btn-check" id="elderly" value={'elderly'} onChange={(e) => handleSelectAnimals(e, 'phase')} onClick={(e) => e.stopPropagation()}></input>
          <label for="elderly">Idoso</label>
          
          <input type="checkbox" className="w-auto btn-check" id="small" value={'small'} onChange={(e) => handleSelectAnimals(e, 'size')} onClick={(e) => e.stopPropagation()}></input>
          <label for="small">Porte pequeno</label>
          
          <input type="checkbox" className="w-auto btn-check" id="medium" value={'medium'} onChange={(e) => handleSelectAnimals(e, 'size')} onClick={(e) => e.stopPropagation()}></input>
          <label for="medium">Porte médio</label>
          
          <input type="checkbox" className="w-auto btn-check" id="large" value={'large'} onChange={(e) => handleSelectAnimals(e, 'size')} onClick={(e) => e.stopPropagation()}></input>
          <label for="large">Porte grande</label>
          
          <input type="checkbox" className="w-auto btn-check" id="undefined" value={'undefined'} onChange={(e) => handleSelectAnimals(e, 'size')} onClick={(e) => e.stopPropagation()}></input>
          <label for="undefined">Porte indefinido</label>
          
          <input type="checkbox" className="w-auto btn-check" id="castrated" value={'1'} onChange={(e) => handleSelectAnimals(e, 'is_castrated')}></input>
          <label for="castrated">Castrado</label>
          
          <input type="checkbox" className="w-auto btn-check" id="not-castrated" value={'0'} onChange={(e) => handleSelectAnimals(e, 'is_castrated')}></input>
          <label for="not-castrated">Não castrado</label>
          
          <input type="checkbox" className="w-auto btn-check" id="special" value={'1'} onChange={(e) => handleSelectAnimals(e, 'special_animal')}></input>
          <label for="special">Especial</label>

          <input type="checkbox" className="w-auto btn-check" id="pinned" value={'1'} onChange={(e) => handleSelectAnimals(e, 'is_pinned')}></input>
          <label for="pinned">Fixado</label>

          <input type="checkbox" className="w-auto btn-check" id="not-pinned" value={'0'} onChange={(e) => handleSelectAnimals(e, 'is_pinned')}></input>
          <label for="not-pinned">Não fixado</label>

          <input type="checkbox" className="w-auto btn-check" id="adopted" value={'1'} onChange={(e) => handleSelectAnimals(e, 'was_adopted')}></input>
          <label for="adopted">Adotado</label>

          <input type="checkbox" className="w-auto btn-check" id="not-adopted" value={'0'} onChange={(e) => handleSelectAnimals(e, 'was_adopted')}></input>
          <label for="not-adopted">Não Adotado</label>
        </div>
        <TableContainer>
          <div className="d-flex align-items-center justify-content-center">
            {isLoading && (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            )}
          </div>
          {!isLoading && (
            <>
              {isFiltering && (
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              )}
              {!isFiltering && (
                <>
                  <Pagination
                    onPaginate={handlePagination}
                    showOnBottom={!isPaginating && tableData.data.length > 0}
                    showOnTop={tableData.data.length > 0}
                    paginateData={tableData}
                  >
                    {!isPaginating && (
                      <>
                        <div className={styles.table_container}>
                          <table className={`table`}>
                            <thead className={`${isLoading ? "d-none" : ""}`}>
                              <tr>
                                <th>ID</th>
                                <th>Nome</th>
                                <th>Especie</th>
                                <th>Gênero</th>
                                <th>Porte</th>
                                <th>Foto</th>
                                <th>Última Edição</th>
                                <th>Ações</th>
                              </tr>
                            </thead>
                            <tbody>
                              {tableData.data.map((item) => (
                                <tr>
                                  <td>{item.id}</td>
                                  <td>{item.name}</td>
                                  <td>{item.species == 'dog' ? "Cachoro": "Gato"}</td>
                                  <td>{item.sex == 'male' ? 'Macho' : 'Fêmea'}</td>
                                  <td>{item.size == 'small' ? 'Pequeno' : (item.size == 'medium' ? 'Médio' : (item.size == 'large' ? 'Grande' : 'Indefinido'))}</td>
                                  <td><img className={styles.animalIcon} src={item.animal_img} alt="" /></td>
                                  <td>{format(new Date(item.updated_at), "d 'de' MMMM 'de' yyyy 'às' H:mm", { locale: ptBR })}</td>
                                  <td>
                                    <div className="d-flex align-items-center">
                                      <ModalAnimal
                                        idAnimal={item.id}
                                        onUpdate={handleUpdateAnimal}
                                      />
                                      &nbsp;
                                      <ModalAnimalInfo
                                        idAnimal={item.id}>
                                          <button type="button" class="btn btn-primary">
                                            <i class="bi bi-info-circle" />
                                          </button>
                                      </ModalAnimalInfo>
                                      &nbsp;
                                      <Link to={`/admin/animais/imagens/${item.id}`}>
                                        <button className="btn btn-info">
                                          <i class="bi bi-camera-fill text-light"/>
                                        </button>
                                      </Link>
                                      &nbsp;
                                      <button
                                        className="btn btn-danger"
                                        onClick={() => onDelete(item)}
                                      >
                                        <i className="bi bi-trash-fill" />
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </>
                    )}
                    {isPaginating && (
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    )}
                    {tableData.data.length === 0 && (
                      <h5 className="text-purple-3 text-center">
                        Não foram encontrados registros com estes filtros.
                      </h5>
                    )}
                  </Pagination>
                </>
              )}
            </>
          )}
        </TableContainer>
      </div>
    </>
  );
}